<div class="tt-c-summary-dim tt-c-dim-distribution tt-u-spacing--sm">
  <div class="tt-c-summary-dim__heading" role="heading" :aria-level="headingLevel"><slot></slot></div>
  <div class="tt-c-dim-distribution__graph">
    <div v-for="item in items" class="tt-c-dim-distribution__item" :style="{width: barWidth + '%'}">
      <div class="tt-c-dim-distribution__bar"
           :class="{'tt-c-dim-distribution__bar--max': item.isMax}"
           :aria-hidden="true"
           :data-value="item.value"
           :style="{height: item.height}"></div>
      <div class="tt-u-clip-hide" v-html="item.desc"></div>
    </div>
  </div>
  <div class="tt-c-dim-distribution__option-labels">
    <span v-for="vLabel in valueLabels" class="tt-c-summary-dim__text" aria-hidden="true">{{vLabel}}</span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/reviews-summary/dim-distribution.html